<script setup>
import {inject, useSlots} from 'vue'

const slots = useSlots()

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: '',
    },
    localizetitle: {
        type: Boolean,
        required: false,
        default: false,
    },
    value: {
        type: String,
        required: true
    },
    active: {
        type: Boolean,
        required: false,
        default: false
    },
})

const selectedTitle = inject('selectedTitle')

</script>
<template>
    <div
        v-show="value === selectedTitle"
        class="relative"
        role="tabpanel"
    >
        <slot></slot>

        <div
            v-if="slots['action-left'] || slots['action-right']"
            class="flex justify-between -mb-4 -mx-4 px-4 py-2 relative mt-4"
        >
            <div><slot name="action-left"></slot></div>
            <div><slot name="action-right"></slot></div>
        </div>
    </div>
</template>
